import { Dialog, Transition } from "@headlessui/react"
import Link from "next/link";
import { Fragment } from "react";
import whatsappIcon from "../assets/whatsapp.svg"
import mailIcon from "../assets/mail.svg"
import Image from "next/image";
import { CloseIcon } from "./icons/CloseIcon";
import { useTranslation } from "react-i18next";

interface ShareModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    href: string;
}

export const ShareModal = ({ isOpen, onClose, title, href }: ShareModalProps) => {
    const { t } = useTranslation()
    return <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-30" onClose={onClose}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-black bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-80 mt-40 justify-center p-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-[600px] max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <Dialog.Title
                                as="h3"
                                className="text-xl pb-4 font-medium leading-6 text-gray-900 relative flex"
                            >
                                {t("share.text")} {title}
                                <button className="absolute -right-2 bottom-6" onClick={onClose}>
                                    <CloseIcon />
                                </button>
                            </Dialog.Title>
                            <div className="mt-2 flex justify-center gap-20">
                                <Link target="_blank" href={`https://api.whatsapp.com/send?text=Te Recomiendo probar ${title} en Auravant: https://auravant.auravant.com/marketplace?utm_source=whatsapp&utm_medium=share&utm_campaign=install_extension%23install=${href}`} className="flex flex-col items-center">
                                    <Image src={whatsappIcon} alt="whatsappIcon" />
                                    <span>Whatsapp</span>
                                </Link>
                                <Link href={`mailto:?Subject=${title} Auravant&body=Te recomiendo probar ${title} en Auravant: https://auravant.auravant.com/marketplace%3Futm_source=email%26utm_medium=share%26utm_campaign=install_extension%23install=${href}`} className="flex flex-col items-center">
                                    <Image src={mailIcon} alt="mainIcon" />
                                    <span>Mail</span>
                                </Link>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </div>
        </Dialog>
    </Transition>
}